import React, { useState } from "react";
import { MDBCol, MDBRow } from "mdbreact";
import { Button, Text, TextInput } from "evergreen-ui";
import { message, Select } from "antd";
import { useListVals } from "../../../Firebase/databaseHooks";
import Firebase from "../../../Firebase/Firebase";
import { getDatabase, ref } from "firebase/database";
import { v4 as uuidv4 } from "uuid";
import { filterSelectOption, sortSelectOptions } from "../../../utils/selectOptions.js";

const db = getDatabase(Firebase);
const InitiativeActionLayout = (props) => {

	const [name, setName] = useState(null);
	const [code, setCode] = useState(null);
	const [langArray] = useListVals(ref(db, "talmidsdb/languages"));
	const [sectors] = useListVals(ref(db, "talmidsdb/initiativeTypes"));
	const [selectedLang, setSelectedLang] = useState(null);
	const [selectedSector, setSelectedSector] = useState(null);

	const handleLang = (value) => {
		setSelectedLang(value);
	}

	const handleSector = (value) => {
		setSelectedSector(value);
	}

	const handleCreate = () => {
		if (!name?.trim() || !code?.trim() || !selectedLang || !selectedSector) {
			message.error("Name, code, language and sector are required.");
			return;
		}

		if (name.includes("/")) {
			message.error("The initiative name cannot include a slash.");
			return;
		}

		var trimmedName = name.trim();
		var trimmedCode = code.trim();
		var object = {
			"id": uuidv4(),
			"sector": selectedSector,
			"initiativeSector": selectedSector,
			"languageId": selectedLang,
			"language": selectedLang,
			"code": trimmedCode,
			"dateCreated": Date.now(),
			"createdBy": props.user?.uid || "unknown",
			"languageName": langArray.find((item) => item.languageID === selectedLang || item.id === selectedLang)?.language ||
				langArray.find((item) => item.languageID === selectedLang || item.id === selectedLang)?.languageName || "",
			"sectorName": sectors.find((item) => item.id === selectedSector)?.name || "",
			"initiative": trimmedName,
			"title": trimmedName,
			"notes": "",
			"status": "pending",
		}
		const objectID = object.id;

		setSelectedLang(null); setSelectedSector(null); setName(""); setCode("");
		props.createCallback("initiatives", objectID, object);
	}

	return (
		<div className="font-Nunito">
			<MDBRow>
				<MDBCol>
					<div className="d-flex flex-column">
						<div className="d-flex flex-column my-2 mt-3">
							<Text className=" mb-1">Enter initiative Name</Text>
							<TextInput
								className="w-100"
								name="text-input-name"
								placeholder="enter initiative"
								onChange={(e) => { setName(e.target.value) }}
								value={name}
							/>
						</div>
						<div className="d-flex flex-column my-2">
							<Text className=" mb-1">Enter initiative Code</Text>
							<TextInput
								className="w-100"
								name="text-input-name"
								placeholder="enter initiative"
								onChange={(e) => { setCode(e.target.value) }}
								value={code}
							/>
						</div>
						<div className="d-flex flex-column my-2">
							<Text className=" mb-1">Select Initiative Language</Text>
							<Select placeholder="Select Language"
								value={selectedLang}
								showSearch
								optionFilterProp="children"
								filterOption={filterSelectOption}
								filterSort={sortSelectOptions}
								onChange={handleLang}>
								{langArray.map((item, index) => (
									<Select.Option key={index} value={item.languageID || item.id}>
										{item.language || item.languageName}
									</Select.Option>
								))}

							</Select>
						</div>

						<div className="d-flex flex-column my-2">
							<Text className=" mb-1">Select Initiative Sector</Text>
							<Select placeholder="Select Initiative Sector"
								value={selectedSector}
								showSearch
								optionFilterProp="children"
								filterOption={filterSelectOption}
								filterSort={sortSelectOptions}
								onChange={handleSector}>
								{sectors.map((item, index) => (
									<Select.Option key={index} value={item.id}>{item.name}</Select.Option>
								))}

							</Select>
						</div>


					</div>
					<Button appearance="primary" className="mt-3" onClick={() => {
						handleCreate();
					}}>Add</Button>
				</MDBCol>
			</MDBRow>
		</div>
	)
}
export default InitiativeActionLayout;
